
import { Vue, Component, Prop } from 'vue-property-decorator'
import library from '@/assets/images/default-library.png'
import list from '@/assets/images/list-nodata.png'

const imageTypes: any = { library, list }

@Component({
  name: 'NoData'
})
export default class NoData extends Vue {
  @Prop({ default: '', type: String }) noDataText: string
  @Prop({ default: 'library', type: String }) type: string

  get imageUrl() {
    return imageTypes[this.type]
  }
}
